import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import classNames from 'classnames'
import { Typography } from '@material-ui/core'
// import { Icon, IconButton } from '@material-ui/core'
import { connect } from 'react-redux'
import * as quickPanelActions from 'main/quickPanel/store/actions'
import { bindActionCreators } from 'redux'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  seperator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider
  }
})

class MainToolbar extends Component {
  render () {
    const { classes } = this.props
    // const { toggleQuickPanel } = this.props

    return (
      <div className={classNames(classes.root, 'flex flex-row')}>

        <div className='flex flex-1 px-24'>
          <Typography>MioAssicuratore</Typography>
        </div>

        <div className='flex'>

          <div className={classes.seperator} />

          {/* <IconButton className='w-64 h-64' onClick={() => toggleQuickPanel(true)}>
            <Icon>format_list_bulleted</Icon>
    </IconButton> */}
        </div>
      </div>
    )
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    toggleQuickPanel: quickPanelActions.toggleQuickPanel
  }, dispatch)
}

export default withStyles(styles, { withTheme: true })(connect(null, mapDispatchToProps)(MainToolbar))
